import React, { useEffect, useState } from "react";
import DropDown from "../UI/Inputs/DropDown";

import showToast from "../../Helpers/toast";
import useApi from "../../Hooks/useApi";
import Button from "../UI/Buttons/Button";


const INITIAL = {
  userId: 0,
  userType: "" /*,
     "permissions": [
      0
    ] */,
};

const ActivateUser = ({ user, onClose, refetch }) => {
  const { userId } = user;
  const [roleId, setRoleId] = useState("");
  const [roles, setRoles] = useState([]);
  const { request } = useApi();

  const fetchRoles = async () => {
    try {
      const response = await request("GET", "/v1/roles");
  
    
      setRoles(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleActivate = async ({ rejectMode }) => {
    const activationData = rejectMode
      ? { ...{ userType: roleId, userId: userId }, declined: true }
      : { ...{ userType: roleId, userId: userId } };

    if ((rejectMode && userId) || (userId && roleId)) {
      try {
        const response = await request("POST", "/v1/user/activate", {
          data: activationData,
        });

        onClose();
        refetch();
        showToast({ message: response?.message });
      } catch (error) {
        showToast({
          message:
            error?.response?.data?.message ||
            `User ${rejectMode ? "Rejection" : "Activation"} Failed!`,
          type: "error",
        });
      }
    } else {
      showToast({ message: "Enter valid role!", type: "error" });
    }
  };

  const handleReject = (e) => {
    handleActivate({ rejectMode: true });
    onClose();
  };

  return (
    <div className="space-y-2">
      <div className="pb-3">
        <DropDown
          label="Role"
          placeholder={"Select Role"}
          name="userType"
          onValueChange={(value) => setRoleId(value)}
          value={roleId}
          options={roles.map((role) => ({
            name: role.name,
            value: role.id,
          }))}
        />
      </div>

      <div className="flex gap-3">
        <Button type={"full"} handler={handleActivate} label={"Assign"}  style={{ color: "white", backgroundColor: "#1976d2" }}/>
        <Button
          style={{ color: "red",  backgroundColor: "#ffe5e9", 
    border: "1px solid #E2123C"}}
          type={"full"}
          handler={handleReject}
          label={"Reject"}
        />
      </div>

    </div>
  );
};

export default ActivateUser;
